import React, { useState, useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Select, MenuItem, FormControl, InputLabel, Box, FormHelperText } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import Spinner from '../Layout/Spinner';
import TextField from '@mui/material/TextField';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  TablePagination,
  TableSortLabel
} from '@mui/material';
import './coordinator.css';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosConfig';
import config from '../../utils/Config';
import coordinatorService from '../../features/coordinator/coordinatorService';
import Tooltip from '@mui/material/Tooltip';
import * as ld from 'lodash';
import saveIcon from '../../assets/images/save_close_new.png';
import discardIcon from '../../assets/images/discard_new.png';
import dashboardUserIcon from '../../assets/images/dashboardUser_new.png';
import orderReportIcon from '../../assets/images/orderReport_new.png';
import dcExportIcon from '../../assets/images/dcExport_new.png';
import enrollmentExportIcon from '../../assets/images/enrollmentExport_new.png';
import surveyExportIcon from '../../assets/images/surveyExport_new.png';
import editDCIcon from '../../assets/images/editDC_new.png';
import addDc from '../../assets/images/addDC_new.png';
import transferOwnership from '../../assets/images/transferOwnership_new.png';
import deleteDC from '../../assets/images/deleteDC_new.png';
import editUser1 from '../../assets/images/editUser1.png';


const mapUserID = [];

function Coordinator(props) {

  const navigate = useNavigate()
  const [countylist, setCounties] = useState([]);
  const [selectedCounty, setSelectedCounty] = useState('');
  const [districtlist, setDistricts] = useState([]);
  const [districtAddlist, setAddDistricts] = useState([]);
  let [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedApproveStatus, setSelectedApproveStatus] = useState('');
  const [submitStatus, setSubmitStatus] = useState('');
  const [selectedAddDistrict, setAddSelectedDistrict] = useState('');
  const [selectedAddCounty, setSelectedAddCounty] = useState('');
  let [uniqueUsers, setUniqueUsers] = useState([]);
  let [dcdata, setDCData] = useState([]);
  let [allDcData, setAllDcData] = useState([]);
  let [isLoading, setIsLoading] = useState(false);
  let [isRowIndex, setRowIndex] = useState();
  let [deleteDcPopMessage, setDeleteDcPopMessage] = useState('');

  const sortdistrictlist = ld.orderBy(districtlist, [item => item.name.toLowerCase()], ['asc'])
  const sortedDistricts = ld.orderBy(districtAddlist, [item => item.name.toLowerCase()], ['asc'])


  useEffect(() => {
    document.title = props.title
    fetchCoordinators();
  }, []);

  const fetchCoordinators = () => {
    setIsLoading(true);
    coordinatorService.getCoordinatorPageData().then((response) => {
      let data = response.data;
      let dcdatas = data;
      let countyfilter = localStorage.getItem('countyfilter');
      let districtfilter = localStorage.getItem('districtfilter');
      let approvefilter = localStorage.getItem('approvefilter');
      let submitfilter = localStorage.getItem('submitfilter');
      if(countyfilter || districtfilter || approvefilter || submitfilter){
        if (countyfilter) {
          setSelectedCounty(countyfilter);
          dcdatas = dcdatas.filter((user) => {
            return user.countyId == countyfilter;
          });
        }
    
        if (districtfilter) {
          setSelectedDistrict(districtfilter);
          dcdatas = dcdatas.filter((user) => {
            return user.districtId == districtfilter;
          });
        }
    
        if (approvefilter) {
          setSelectedApproveStatus(approvefilter);
          dcdatas = dcdatas.filter((user) => {
            return user.approveStatus == approvefilter;
          });
        }


        if (submitfilter) {
          setSubmitStatus(submitfilter);
          dcdatas = dcdatas.filter((user) => {
            return user.submitStatus == submitfilter;
          });
        }
        setDCData(dcdatas);
      }
      else{
      setDCData(data.sort((a, b) => {
        // Sort by country
        const countryComparison = a.county.localeCompare(b.county);
        if (countryComparison !== 0) {
          return countryComparison;
        }
        // Sort by state within the same country
        return a.district.localeCompare(b.district);
      }));
    }
      setAllDcData(data.sort((a, b) => {
        // Sort by country
        const countryComparison = a.county.localeCompare(b.county);
        if (countryComparison !== 0) {
          return countryComparison;
        }

        // Sort by state within the same country
        return a.district.localeCompare(b.district);
      }));

      const uniqueRecords = Array.from(
        new Map(
          data
            .filter(obj => obj.approveStatus == 'yes') // Filter out objects where isDeleted is true
            .map(obj => [obj.email, obj])
        ).values()
      ).sort((a, b) => a.email.localeCompare(b.email));

      setUniqueUsers(uniqueRecords);
      setIsLoading(false);
    }).catch(err => {
      toast.error(err.message ? err.message : "Unable to fetch enrollment data.");
      setIsLoading(false);
    })
  }

  useEffect(() => {
    axios.get(config.basePath + 'common/getCountyList')
      .then((response) => {
        // console.log(response);
        const data = response.data;
        setCounties(data.length > 0 ? ld.orderBy(data, [item => item.name.toLowerCase()], ['asc']) : data);
      })
      .catch((error) => console.error(error));
  }, []);


  useEffect(() => {
    if (selectedCounty) {
      const headers = {
        'Content-Type': 'application/json',
      };
      // setSelectedDistrict('');
      // setDistricts([]);
      const academicYear = localStorage.getItem("academicyear");
      axios.get(config.basePath + `common/getDistrictBsCounty?̉̉̉̉̉̉county=${selectedCounty}&academicyear=${academicYear}`, { headers })
        .then((response) => {
          const data = response.data;

          setDistricts(data.districts.length > 0 ? ld.orderBy(data.districts, [item => item.name.toLowerCase()], ['asc']) : data.districts);
          setAddDistricts(data.districts.length > 0 ? ld.orderBy(data.districts, [item => item.name.toLowerCase()], ['asc']) : data.districts);
          // setDCData(allDcData.filter((user) => {
          //   return user.countyId == selectedCounty;
          // }));
        })
        .catch((error) => console.error(error));
    }
  }, [selectedCounty]);

  // change district dropdown population for add user
  useEffect(() => {
    if (selectedAddCounty) {
      const headers = {
        'Content-Type': 'application/json',
      };
      const academicYear = localStorage.getItem("academicyear");
      axios.get(config.basePath + `common/getDistrictBsCounty?̉̉̉̉̉̉county=${selectedAddCounty}&academicyear=${academicYear}`, { headers })
        .then((response) => {
          const data = response.data;
          setAddDistricts(data.districts);
        })
        .catch((error) => console.error(error));
    }
  }, [selectedAddCounty]);



  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(2000);

  const [selectedTransferUserId, setSelectedTransferUserId] = useState('');
  const [isUserDCError, setUserDCError] = useState(false);

  const handleUserSelect = (event) => {
    const selectedValue = event.target.value;
    setSelectedTransferUserId(selectedValue);
    setUserDCError(selectedValue === 'SELECT DC USER');
  };

  const switchUser = (element) => {
    console.log(element);
    if (element.approveStatus == 'yes') {
      localStorage.setItem('userId', element.userId);
      localStorage.setItem('districtId', element.districtId);
      localStorage.setItem('countyId', element.countyId);
      localStorage.setItem('firstName', element.firstName);
      localStorage.setItem('lastName', element.lastName);
      navigate('/home');
    } else {
      toast.warning('Please approve the user');
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [deleteDistrictId, setDeleteDistrictId] = useState(null);
  const [deleteDistrictIndex, setDeleteDistrictIndex] = useState(null);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [username, setUsername] = useState(null);
  const [districtName, setDistrictName] = useState(null);
  const [countyName, setCountyName] = useState(null);


  const onCountySelect = (e) => {
    setSelectedCounty(e.target.value);
    setSelectedDistrict('');
    selectedDistrict = '';
    let dcdata = allDcData;
    if (e.target.value == "") {
      localStorage.removeItem("countyfilter");
      localStorage.removeItem("districtfilter");
      setSelectedDistrict('');
      setDistricts([]);
    }

    if (e.target.value != "") {
      localStorage.setItem('countyfilter', e.target.value);
      dcdata = dcdata.filter((user) => {
        return user.countyId == e.target.value;
      });
    }
    if (e.target.value != "") {
      if (selectedDistrict != "") {
        dcdata = dcdata.filter((user) => {
          return user.districtId == selectedDistrict;
        });
      }
    }

    if (selectedApproveStatus != "") {
      dcdata = dcdata.filter((user) => {
        return user.approveStatus == selectedApproveStatus;
      });
    }

    if (submitStatus != "") {
      dcdata = dcdata.filter((user) => {
        return user.submitStatus == submitStatus;
      });
    }

    setDCData(dcdata);
  };

  const onDistrictSelect = (e) => {
    setSelectedDistrict(e.target.value);

    let dcdata = allDcData;
    if (selectedCounty == "") {
      localStorage.removeItem("districtfilter");
      setDistricts([]);
    }
    if (selectedCounty !== "") {
      dcdata = dcdata.filter((user) => {
        return user.countyId == selectedCounty;
      });
    }
    if (e.target.value == "") {
      localStorage.removeItem("districtfilter");
    }
    if (e.target.value !== "") {
      localStorage.setItem('districtfilter', e.target.value);
      dcdata = dcdata.filter((user) => {
        return user.districtId == e.target.value;
      });
    }

    if (selectedApproveStatus !== "") {
      dcdata = dcdata.filter((user) => {
        return user.approveStatus == selectedApproveStatus;
      });
    }

    if (submitStatus !== "") {
      dcdata = dcdata.filter((user) => {
        return user.submitStatus == submitStatus;
      });
    }

    setDCData(dcdata);
  };

  const onAddDistrictSelect = (e) => {
    setAddSelectedDistrict(e.target.value);
    if (e.target.value == '') {
      setIsDistrictError(true);
    } else {
      setIsDistrictError(false);
    }
  };

  const onAddCountySelect = (e) => {
    setSelectedAddCounty(e.target.value);
    console.log(e.target.value);
    if (e.target.value == '') {
      setIsCountyError(true);
    } else {
      setIsCountyError(false);
    }
  };

  const downloadExceldc = async () => {
    try {
      setIsLoading(true);
      coordinatorService.downloadExcelDC()
        .then((response) => {
          // console.log(response);
          setIsLoading(false);
          // Create a Blob from the response data
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

          // Create a temporary URL for the Blob
          const url = URL.createObjectURL(blob);

          // Create a link element
          const link = document.createElement('a');
          link.href = url;
          link.download = getFileName('DistrictCoordinator');


          // Simulate a click event to trigger the download
          link.click();

          // Clean up the temporary URL and link
          URL.revokeObjectURL(url);
          link.remove();
        })
        .catch((error) => {
          console.log(error);
        });

    } catch (error) {
      console.error('Error:', error);
    }
  };

  const downloadExcelSurvey = async () => {
    setIsLoading(true);
    coordinatorService.downloadExcelSurvey()
      .then((response) => {
        setIsLoading(false);
        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Create a temporary URL for the Blob
        const url = URL.createObjectURL(blob);

        // Create a link element
        const link = document.createElement('a');
        link.href = url;
        link.download = getFileName('SurveyModule');

        // Simulate a click event to trigger the download
        link.click();

        // Clean up the temporary URL and link
        URL.revokeObjectURL(url);
        link.remove();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function formatDateISO8601(date) {
    return date.toISOString().replace(/[-:]/g, '').slice(0, -5);
  }




  const downloadExcelEnr = async () => {
    setIsLoading(true);
    coordinatorService.downloadExcelEnr()
      .then((response) => {
        setIsLoading(false);
        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Create a temporary URL for the Blob
        const url = URL.createObjectURL(blob);

        // Create a link element
        const link = document.createElement('a');
        link.href = url;
        link.download = getFileName('Enrollment');

        // Simulate a click event to trigger the download
        link.click();

        // Clean up the temporary URL and link
        URL.revokeObjectURL(url);
        link.remove();
      })
      .catch((error) => {
        console.log(error);
      });
  }


  const downloadExcelReport = async () => {
    setIsLoading(true);
    coordinatorService.downloadExcelReport()
      .then((response) => {
        setIsLoading(false);
        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Create a temporary URL for the Blob
        const url = URL.createObjectURL(blob);

        // Create a link element
        const link = document.createElement('a');
        link.href = url;
        link.download = getFileName('ReportOrder');

        // Simulate a click event to trigger the download
        link.click();

        // Clean up the temporary URL and link
        URL.revokeObjectURL(url);
        link.remove();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const downloadDbUser = async () => {
    setIsLoading(true);
    await coordinatorService.downloadExcelDbuser()
      .then((response) => {
        setIsLoading(false);
        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Create a temporary URL for the Blob
        const url = URL.createObjectURL(blob);

        // Create a link element
        const link = document.createElement('a');
        link.href = url;
        const currentDate = new Date();
        link.download = getFileName('DashboardUser');;

        // Simulate a click event to trigger the download
        link.click();

        // Clean up the temporary URL and link
        URL.revokeObjectURL(url);
        link.remove();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const onApprovedStatusSelect = (event) => {
    setSelectedApproveStatus(event.target.value);
    let dcdata = allDcData;
    console.log(selectedCounty, selectedDistrict, event.target.value, submitStatus);
    if (selectedCounty !== "") {
      dcdata = dcdata.filter((user) => {
        return user.countyId == selectedCounty;
      });
    }

    if (selectedDistrict !== "") {
      dcdata = dcdata.filter((user) => {
        return user.districtId == selectedDistrict;
      });
    }

    if (event.target.value !== "") {
      localStorage.setItem('approvefilter', event.target.value);
      dcdata = dcdata.filter((user) => {
        return user.approveStatus == event.target.value;
      });
    }else{
      localStorage.removeItem('approvefilter');
    }

    if (submitStatus !== "") {
      dcdata = dcdata.filter((user) => {
        return user.submitStatus == submitStatus;
      });
    }

    setDCData(dcdata);
  }

  const onSubmitStatusSelect = (event) => {
    setSubmitStatus(event.target.value);
    console.log(event.target.value, selectedCounty, selectedDistrict, selectedApproveStatus);

    let dcdata = allDcData;

    if (selectedCounty !== "") {
      dcdata = dcdata.filter((user) => {
        return user.countyId == selectedCounty;
      });
    }

    if (selectedDistrict !== "") {
      dcdata = dcdata.filter((user) => {
        return user.districtId == selectedDistrict;
      });
    }

    if (selectedApproveStatus !== "") {
      dcdata = dcdata.filter((user) => {
        return user.approveStatus == selectedApproveStatus;
      });
    }

    if (event.target.value !== "") {
      localStorage.setItem('submitfilter', event.target.value);
      dcdata = dcdata.filter((user) => {
        return user.submitStatus == event.target.value;
      });
    }else{
      localStorage.removeItem('submitfilter');
    }

    setDCData(dcdata);
  };


  const [open, setOpen] = useState(false);
  const [transferOwnershipOpen, setTransferOwnershipOpen] = useState(false);
  const [userDetailsOpen, sethandleUserDetailsOpen] = useState(false);
  const [oldUserId, setOldUserId] = useState();
  const [trasnferDistrictId, setTransferDistrictId] = useState();
  const [responseNow, setResponseNow] = useState(false);

  ////////////////////////////////////////////////////////////////


  const [userDetailState, setUserDetailState] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    zipCode: ''
  });

  const [isUserError, setIsUserError] = useState({
    firstNameError: false,
    lastNameError: false,
    phoneError: false,
    zipCodeError: false,
    cityError: false,
    addressError: false
  });

  const [isDistrictError, setIsDistrictError] = useState(false);
  const [isCountyError, setIsCountyError] = useState(false)




  const validateForm = () => {
    let isValid = true;

    // Validate First Name
    if (userDetailState.firstName.trim() === '') {
      setIsUserError((prevState) => ({
        ...prevState,
        firstNameError: true
      }));
      isValid = false;
    } else {
      setIsUserError((prevState) => ({
        ...prevState,
        firstNameError: false
      }));
    }

    // Validate Last Name
    if (userDetailState.lastName.trim() === '') {
      setIsUserError((prevState) => ({
        ...prevState,
        lastNameError: true
      }));
      isValid = false;
    } else {
      setIsUserError((prevState) => ({
        ...prevState,
        lastNameError: false
      }));
    }

    // Validate Phone Number
    if (!/^\d{10}$/.test(userDetailState.phone)) {
      setIsUserError((prevState) => ({
        ...prevState,
        phoneError: true
      }));
      isValid = false;
    } else {
      setIsUserError((prevState) => ({
        ...prevState,
        phoneError: false
      }));
    }

    // Validate Zip Code
    if (!/^\d{5}$/.test(userDetailState.zipCode)) {
      setIsUserError((prevState) => ({
        ...prevState,
        zipCodeError: true
      }));
      isValid = false;
    } else {
      setIsUserError((prevState) => ({
        ...prevState,
        zipCodeError: false
      }));
    }

    // Validate cityError
    if (userDetailState.city.trim() === '') {
      setIsUserError((prevState) => ({
        ...prevState,
        cityError: true
      }));
      isValid = false;
    } else {
      setIsUserError((prevState) => ({
        ...prevState,
        cityError: false
      }));
    }

     // Validate addressError
     if (userDetailState.address.trim() === '') {
      setIsUserError((prevState) => ({
        ...prevState,
        addressError: true
      }));
      isValid = false;
    } else {
      setIsUserError((prevState) => ({
        ...prevState,
        addressError: false
      }));
    }

    return isValid;
  };



  const handleInputChange = (e) => {
    validateForm();
    setUserDetailState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value
    }));
  };

  ////////////////////////////////////////////////////////////////  
  const handleOpen = (userId, element, index) => {
    console.log(element);
    setUsername(element.firstName + ' ' + element.lastName);

    const districtsCount = allDcData.filter((user) => user.userId == element.userId).length;
    let msg = `Are you sure you want to delete ${element.firstName + ' ' + element.lastName} (${element.email}) for ${element.district} in ${element.county} County? This is the only district for this user. Deleting this district would remove the DC user.`;
    if (districtsCount > 1) {
      msg = `Are you sure you want to delete ${element.firstName + ' ' + element.lastName} (${element.email}) for ${element.district} in ${element.county} County?`;
    }
    setDeleteDcPopMessage(msg);
    setDeleteDistrictIndex(index);
    setDeleteDistrictId(element.districtId);
    setDeleteUserId(element.userId);
    setDistrictName(element.district);
    setCountyName(element.county);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAllDcDeleteObject = (indexToDelete) => {

    const updatedDcdata = [...allDcData]; // Create a copy of the dcdata state array

    if (indexToDelete >= 0 && indexToDelete < updatedDcdata.length) {
      updatedDcdata.splice(indexToDelete, 1); // Remove the object at the specified index
    }

    return updatedDcdata; // Return the updated array to update the state

  };

  const handleDeleteObject = (indexToDelete) => {

    const updatedDcdata = [...dcdata]; // Create a copy of the dcdata state array

    if (indexToDelete >= 0 && indexToDelete < updatedDcdata.length) {
      updatedDcdata.splice(indexToDelete, 1); // Remove the object at the specified index
    }

    return updatedDcdata; // Return the updated array to update the state

  };

  const deleteUser = async () => {
    setIsLoading(true);
    const requestBody = {
      districtId: deleteDistrictId,
      userId: deleteUserId
    };
    const headers = {
      'Content-Type': 'application/json'
    }
    await axios.post(config.basePath + 'coordinator/deleteDc', requestBody, headers)
      .then(response => {
        setIsLoading(false);
        if (response.data.success) {
          const updatedRecords = handleDeleteObject(deleteDistrictIndex)
          setDCData(updatedRecords);
          setAllDcData(handleAllDcDeleteObject(deleteDistrictIndex))
          setOpen(false);
          toast.success(response.data.message);
          fetchCoordinators();
        } else {
          toast.error(response.data.message);
          setOpen(false);
        }
      })
      .catch(err => {
        setIsLoading(false);
        console.log(err);
      })
  };


  const handleTransferOwnershipOpen = (element, userId, rowindex) => {
    setTransferOwnershipOpen(true);
    setOldUserId(element.userId);
    setTransferDistrictId(element.districtId);
    setSelectedTransferUserId('');
    setRowIndex(rowindex);
    console.log(element);
  };

  const handleTransferOwnershipClose = () => {
    setTransferOwnershipOpen(false);
  };

  const handleUserDetailsClick = (element, userId, rowIndex) => {
    sethandleUserDetailsOpen(true);
    setUserDetailState(element);
    setRowIndex(rowIndex);
  };

  const handleUserDetailsClose = () => {
    sethandleUserDetailsOpen(false);
  }

  const [editedFirstName, setEditedFirstName] = useState('');
  const [editableRows, setEditableRows] = useState([]); // New state variable for editable rows

  const handleEditClick = (user, userId) => {
    setEditableRows([]);
    setSelectedUserApproveStatus(user.approveStatus)
    user.distSubmitType != 'do' ? setSelectedReportSubmitStatus(user.submitStatus) : setSelectedReportSubmitStatus('yes');
    setSelectedOrderReport(user.reportPage);
    if (editableRows.includes(userId) || editableRows.length > 0) {
      setEditableRows([]);
    } else {
      setEditableRows([...editableRows, userId]);
    }
  };
  const handleYearSelection = () => {
    toast.error("Restricted in historical data view");
  };

  const handleSaveClick = (element, rowIndex) => {
    // Perform save logic here
    console.log(element);
    // Call the API to update the user
    element.submitStatus = selectedReportSubmitStatus;
    axios.put(config.basePath + `user/updateuser/${element.userId}`, element)
      .then(response => {
        fetchCoordinators();
        // Handle the response after updating the user
        if (response.status == 200) {
          console.log(response.data.data);
          setSelectedUserApproveStatus(response.data.data ? 'yes' : 'no');
          setResponseNow(true);
          setEditableRows([]);
          if(response.data.message==='An approved account with this district already exists. Please change the account approval status before adding this district.'){
            toast.error(response.data.message);
          }
          else{
            toast.success(response.data.message);
          }
          dcdata[rowIndex].approveStatus = response.data.data ? 'yes' : 'no';
          if (!response.data.data) {
            uniqueUsers = uniqueUsers.filter(obj => obj.email != element.email) // Filter out objects where isDeleted is true
            setUniqueUsers(uniqueUsers);
          }
          // dcdata[rowIndex].submitStatus = response.data.submitStatus == 'yes' ? 'yes' : 'no';
          if (response.data.distSubmitType == 'dowd') {
            dcdata[rowIndex].distSubmitType = 'dowd';
          }

        } else {
          toast.error('Something went wrong');
        }

        // Perform any necessary actions or update the state accordingly
      })
      .catch(error => {
        // Handle any errors that occurred during the API call
        console.error(error);
      });
  };

  const discardRow = () => {
    setEditableRows([]);
  };


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rowElement, setRowElement] = useState();
  let [selectedRowId, setRowId] = useState("");
  let [selectedUserApproveStatus, setSelectedUserApproveStatus] = useState('');
  let [selectedReportSubmitStatus, setSelectedReportSubmitStatus] = useState();
  let [selectedOrderReport, setSelectedOrderReport] = useState();

  const toggleModal = (rowId, element) => {
    setRowId(rowId);
    setRowElement(element);
    setIsModalOpen(!isModalOpen);
    setAddSelectedDistrict('');
    setSelectedAddCounty('');
  };

  const handleDistrictSave = () => {

    if (selectedAddCounty != '' && selectedAddDistrict != '') {
      addDistrictData(selectedAddCounty, selectedAddDistrict, rowElement.userId);
    } else {
      selectedAddCounty == '' ? setIsCountyError(true) : setIsCountyError(false);
      selectedAddDistrict == '' ? setIsDistrictError(true) : setIsDistrictError(false);
      toast.warning('Please select county & district');
    }
    // toggleModal();
  };


  const addDistrictData = async (countyId, districtId, selectedUserId) => {
    setIsLoading(true);
    const requestBody = {
      districtId: districtId,
      userId: selectedUserId
    };
    await axios.post(config.basePath + 'coordinator/addDC', requestBody)
      .then(response => {
        setIsModalOpen(false);
        setIsLoading(false);
        if (response.data.success) {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch(err => {
        setIsModalOpen(false);
        setIsLoading(false);
        console.log(err);
      })
  };

  const onSelectUserApprooveStatus = (e) => {
    setSelectedUserApproveStatus(e);
  }

  const handleTransferDistrict = (e) => {
    // {oldUserId, newUserId, districtId}
    setIsLoading(true);
    coordinatorService.trasnferDc({ oldUserId, 'newUserId': selectedTransferUserId, 'districtId': trasnferDistrictId })
      .then((response) => {
        console.log(response.data.success);
        setIsLoading(false);
        if (response.data.success) {
          // setIsLoading(true);
          // console.log(response.data);
          // dcdata[isRowIndex].firstName = response.data.userData.firstName;
          // dcdata[isRowIndex].lastName = response.data.userData.lastName;
          // dcdata[isRowIndex].email = response.data.userData.email;
          // dcdata[isRowIndex].phone = response.data.userData.phone;
          // dcdata[isRowIndex].city = response.data.userData.city;
          // dcdata[isRowIndex].zipCode = response.data.userData.zipCode;
          // setSelectedTransferUserId('');
          toast.success('DC Transfer successfully done!');
          fetchCoordinators();
        }
        setTransferOwnershipOpen(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        toast.error(err.message);
        setTransferOwnershipOpen(false);
        setSelectedTransferUserId('');
      })
  }
  const [orderBy, setOrderBy] = useState('');
  const [order, setOrder] = useState('asc');


  const handleSort = (column) => {
    const isAsc = orderBy === column && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(column);
  };

// Function to convert a date to PST (Pacific Standard Time)
function convertToPST(date) {
    const offset = -7 * 60; // PST is UTC-8
    const utcTimestamp = date.getTime() + (date.getTimezoneOffset() * 60 * 1000);
    const pstTimestamp = utcTimestamp + (offset * 60 * 1000);
    return new Date(pstTimestamp);
}

/* Generate file Name */
function getFileName(moduleName) {
  let today = new Date();
  try {
    let dd = today.getDate();
    let mm = today.getMonth() + 1; //January is 0!
    let ss = today.getSeconds();
    let hoursMint = `${today.getHours()}${today.getMinutes()}${ss}`;

    let yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    /* replace \/ or (|) \\  or \s+ "one or more spaces" and /g flag to remove all occurrences */
    today = `${moduleName}_${yyyy}${mm}${dd}${hoursMint}.xlsx`;
  } catch (error) {
    console.log(`ERROR: ${error}, in pdfFileName().`);
  }
  return today;
}

  const handleUserDetailsUpdate = () => {
    if (validateForm()) {
      setIsLoading(true);
      console.log(userDetailState);
      axios.put(config.basePath + `user/updateusermodel/${userDetailState.userId}`, userDetailState)
        .then(response => {
          setIsLoading(false);
          // Handle the response after updating the user
          if (response.status == 200) {
            console.log(response.data);
            dcdata[isRowIndex].firstName = response.data.data.firstName;
            dcdata[isRowIndex].lastName = response.data.data.lastName;
            dcdata[isRowIndex].phone = response.data.data.phone;
            dcdata[isRowIndex].city = response.data.data.city;
            dcdata[isRowIndex].zipCode = response.data.data.zipCode;
            dcdata[isRowIndex].address = response.data.data.address;

            allDcData[isRowIndex]['firstName'] = response.data.data.firstName;
            allDcData[isRowIndex]['lastName'] = response.data.data.lastName;
            allDcData[isRowIndex]['phone'] = response.data.data.phone;
            allDcData[isRowIndex]['city'] = response.data.data.city;
            allDcData[isRowIndex]['zipCode'] = response.data.data.zipCode;
            allDcData[isRowIndex]['address'] = response.data.data.address;

            toast.success('User updated successfully');
          } else {
            toast.error('Something went wrong');
          }
          sethandleUserDetailsOpen(false);
          // Perform any necessary actions or update the state accordingly
        })
        .catch(error => {
          // Handle any errors that occurred during the API call
          sethandleUserDetailsOpen(false);
          setIsLoading(false);
          console.error(error);
        });
    }
  };
  return (
    <>
      {(isLoading === true) ? <Spinner></Spinner> : ""}
      <div className='pageHeader'>
        {/* <div className="pageText">District Coordinators</div> */}
        <div class="coordinator_DateTab">
          <div className="pageText">District Coordinators</div>
          {localStorage.getItem('academicyear') === 'currentyear' && (
          <div className='excelColRight'>
            {/* <Tooltip title='Click to download Dashboard Users' placement="bottom-start"><img className='downloadExcelIconSize' onClick={downloadDbUser} src={require("../../assets/images/dashboardUser.png")} alt="Dashboard User Excel" /></Tooltip>
            <Tooltip title='Click to download Order Report' placement="bottom-start"><img className='downloadExcelIconSize' onClick={downloadExcelReport} src={require("../../assets/images/orderReport.png")} alt="Order Report Excel" /></Tooltip>
            <Tooltip title='Click to download DC Users' placement="bottom-start"><img className='downloadExcelIconSize' onClick={downloadExceldc} src={require("../../assets/images/dcExport.png")} alt="DC Export Excel" /></Tooltip>
            <Tooltip title='Click to download Enrollment' placement="bottom-start"><img className='downloadExcelIconSize' onClick={downloadExcelEnr} src={require("../../assets/images/enrollmentExport.png")} alt="Enrollment Export Excel" /></Tooltip>
            <Tooltip title='Click to download Survey Module' placement="bottom-start"><img className='downloadExcelIconSize' onClick={downloadExcelSurvey} src={require("../../assets/images/surveyExport.png")} alt="Survey Export Excel" /></Tooltip> */}
            <Tooltip title='Click to download Dashboard Users' placement="bottom-start"><img className='downloadExcelIconSize' onClick={downloadDbUser} src={dashboardUserIcon} alt="Dashboard User Excel" /></Tooltip>
            <Tooltip title='Click to download Order Report' placement="bottom-start"><img className='downloadExcelIconSize' onClick={downloadExcelReport} src={orderReportIcon} alt="Order Report Excel" /></Tooltip>
            <Tooltip title='Click to download DC Users' placement="bottom-start"><img className='downloadExcelIconSize' onClick={downloadExceldc} src={dcExportIcon} alt="DC Export Excel" /></Tooltip>
            <Tooltip title='Click to download Enrollment' placement="bottom-start"><img className='downloadExcelIconSize' onClick={downloadExcelEnr} src={enrollmentExportIcon} alt="Enrollment Export Excel" /></Tooltip>
            <Tooltip title='Click to download Survey Module' placement="bottom-start"><img className='downloadExcelIconSize' onClick={downloadExcelSurvey} src={surveyExportIcon} alt="Survey Export Excel" /></Tooltip>
          </div>
          )}
        </div>

      </div>
      <div className='pageContent'>
        <Grid container spacing={4}>

          {/* Filter Dropdowns */}
          <Grid item xs={3}>
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
              <FormControl variant="standard" sx={{ m: 1, minWidth: 120, width: '100%' }}>
                <InputLabel id="county-label">Select County</InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  label="Select a county"
                  value={selectedCounty}
                  onChange={onCountySelect}
                  MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                >
                  <MenuItem value="">SELECT COUNTY</MenuItem>
                  {countylist.map((county) => (
                    <MenuItem key={county._id} value={county._id}>
                      {county.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={3}>
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
              <FormControl variant="standard" sx={{ m: 1, minWidth: 120, width: '100%', }}>
                <InputLabel id="county-label">Select District</InputLabel>
                <Select
                  labelId="district-label"
                  value={selectedDistrict}
                  onChange={onDistrictSelect}
                  MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                >
                  <MenuItem value="">SELECT DISTRICT</MenuItem>
                  {sortdistrictlist.map((dist) => (
                    <MenuItem key={dist._id} value={dist._id}>
                      {dist.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={3}>
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
              <FormControl variant="standard" sx={{ m: 1, minWidth: 150, width: '100%' }}>
                <InputLabel id="approvedStatus-label">Select Approved Status</InputLabel>
                <Select
                  labelId="approvedStatus-label"
                  value={selectedApproveStatus}
                  onChange={onApprovedStatusSelect}
                  sx={{ width: '100%' }}
                >
                  <MenuItem value="">SELECT APPROVED STATUS</MenuItem>
                  <MenuItem value="yes">Yes</MenuItem>
                  <MenuItem value="no">No</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <FormControl variant="standard" style={{ padding: '5px', width: '90%' }}>
              <InputLabel id="submitStatus-label" style={{ padding: '5px' }}>Select Submit Status</InputLabel>
              <Select
                labelId="submitStatus-label"
                value={submitStatus}
                onChange={onSubmitStatusSelect}
              >
                <MenuItem value="">SELECT SUBMIT STATUS</MenuItem>
                <MenuItem value="yes">Yes</MenuItem>
                <MenuItem value="no">No</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid><div>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow className='coordinator_tableHeaderRow'>
                  <TableCell className="coordinator_tableHeaderCell coordinator_actionHeader" style={{ padding: '0px', minWidth: '130px' }}>Actions</TableCell>
                  <TableCell className="coordinator_tableHeaderCell coordinator_otherHeader" style={{ width: '90px' }}>
                    <TableSortLabel
                      active={orderBy === 'County'}
                      direction={orderBy === 'County' ? order : 'asc'}
                      onClick={(event) => {
                        event.preventDefault();
                        handleSort('County')
                      }}
                    >
                      County
                    </TableSortLabel>
                  </TableCell>
                  <TableCell className="coordinator_tableHeaderCell coordinator_otherHeader" style={{ width: '250px' }}>
                    <TableSortLabel
                      active={orderBy === 'District'}
                      direction={orderBy === 'District' ? order : 'asc'}
                      onClick={(event) => {
                        event.preventDefault();
                        handleSort('District')
                      }}
                    >
                      District
                    </TableSortLabel>
                  </TableCell>
                  <TableCell className="coordinator_tableHeaderCell coordinator_otherHeader" style={{ width: '20px' }}>
                    <TableSortLabel
                      active={orderBy === 'FirstName'}
                      direction={orderBy === 'FirstName' ? order : 'asc'}
                      onClick={(event) => {
                        event.preventDefault();
                        handleSort('FirstName')
                      }}
                    >
                      FirstName
                    </TableSortLabel>
                  </TableCell>
                  <TableCell className="coordinator_tableHeaderCell coordinator_otherHeader" style={{ width: '30px' }}>
                    <TableSortLabel
                      active={orderBy === 'LastName'}
                      direction={orderBy === 'LastName' ? order : 'asc'}
                      onClick={(event) => {
                        event.preventDefault();
                        handleSort('LastName')
                      }}
                    >
                      LastName
                    </TableSortLabel>
                  </TableCell>
                  <TableCell className="coordinator_tableHeaderCell coordinator_otherHeader" style={{ width: '30px' }}>
                    <TableSortLabel
                      active={orderBy === 'Email'}
                      direction={orderBy === 'Email' ? order : 'asc'}
                      onClick={(event) => {
                        event.preventDefault();
                        handleSort('Email')
                      }}
                    >
                      Email
                    </TableSortLabel>
                  </TableCell>
                  <TableCell className="coordinator_tableHeaderCell coordinator_otherHeader" style={{ width: '30px' }}>
                    <TableSortLabel
                      active={orderBy === 'Phone'}
                      direction={orderBy === 'Phone' ? order : 'asc'}
                      onClick={(event) => {
                        event.preventDefault();
                        handleSort('Phone')
                      }}
                    >
                      Phone
                    </TableSortLabel>
                  </TableCell>
                  <TableCell className="coordinator_tableHeaderCell coordinator_otherHeader" style={{ width: '100px' }}>
                    <TableSortLabel
                      active={orderBy === 'City'}
                      direction={orderBy === 'City' ? order : 'asc'}
                      onClick={(event) => {
                        event.preventDefault();
                        handleSort('City')
                      }}
                    >
                      City
                    </TableSortLabel>
                  </TableCell>
                  <TableCell className="coordinator_tableHeaderCell coordinator_otherHeader" style={{ width: '30px' }}>
                    <TableSortLabel
                      active={orderBy === 'ZipCode'}
                      direction={orderBy === 'ZipCode' ? order : 'asc'}
                      onClick={(event) => {
                        event.preventDefault();
                        handleSort('ZipCode')
                      }}
                    >
                      ZipCode
                    </TableSortLabel>
                  </TableCell>
                  <TableCell className="coordinator_tableHeaderCell coordinator_statusHeader" style={{ width: '20px' }}>
                    <TableSortLabel
                      active={orderBy === 'Account Approved'}
                      direction={orderBy === 'Account Approved' ? order : 'asc'}
                      onClick={(event) => {
                        event.preventDefault();
                        handleSort('Account Approved')
                      }}
                    >
                      Account Approved
                    </TableSortLabel>
                  </TableCell>
                  <TableCell className="coordinator_tableHeaderCell coordinator_statusHeader" style={{ width: '20px' }}>
                    <TableSortLabel
                      active={orderBy === 'Registration Submitted'}
                      direction={orderBy === 'Registration Submitted' ? order : 'asc'}
                      onClick={(event) => {
                        event.preventDefault();
                        handleSort('Registration Submitted')
                      }}
                    >
                      Registration Submitted
                    </TableSortLabel>
                  </TableCell>
                  <TableCell className="coordinator_tableHeaderCell coordinator_statusHeader" style={{ width: '20px' }}>
                    <TableSortLabel
                      active={orderBy === 'Report Ordered'}
                      direction={orderBy === 'Report Ordered' ? order : 'asc'}
                      onClick={(event) => {
                        event.preventDefault();
                        handleSort('Report Ordered')
                      }}
                    >
                      Report Ordered
                    </TableSortLabel>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dcdata.sort((a, b) => {
                  if (orderBy === 'County') {
                    return order === 'asc' ? a.county.localeCompare(b.county) : b.county.localeCompare(a.county);
                  }
                  if (orderBy === 'FirstName') {
                    return order === 'asc' ? a.firstName.localeCompare(b.firstName) : b.firstName.localeCompare(a.firstName);
                  }
                  if (orderBy === 'LastName') {
                    return order === 'asc' ? a.lastName.localeCompare(b.lastName) : b.lastName.localeCompare(a.lastName);
                  }
                  if (orderBy === 'Email') {
                    return order === 'asc' ? a.email.localeCompare(b.email) : b.email.localeCompare(a.email);
                  }
                  if (orderBy === 'City') {
                    return order === 'asc' ? a.city.localeCompare(b.city) : b.city.localeCompare(a.city);
                  }
                  if (orderBy === 'ZipCode') {
                    return order === 'asc' ? a.zipCode - b.zipCode : b.zipCode - a.zipCode;
                  }
                  if (orderBy === 'Phone') {
                    return order === 'asc' ? a.phone.localeCompare(b.phone) : b.phone.localeCompare(a.phone);
                  }
                  if (orderBy === 'District') {
                    return order === 'asc' ? a.district.localeCompare(b.district) : b.district.localeCompare(a.district);
                  }
                  if (orderBy === 'Account Approved') {
                    return order === 'asc' ? a.approveStatus.localeCompare(b.approveStatus) : b.approveStatus.localeCompare(a.approveStatus);
                  }
                  if (orderBy === 'Registration Submitted') {
                    return order === 'asc' ? a.submitStatus.localeCompare(b.submitStatus) : b.submitStatus.localeCompare(a.submitStatus);
                  }
                  if (orderBy === 'Report Ordered') {
                    return order === 'asc' ? a.reportPage.localeCompare(b.reportPage) : b.reportPage.localeCompare(a.reportPage);
                  }
                  // Repeat the above pattern for each column
                  return 0; // Default sorting (no column selected)
                })
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((element, index) => (
                    <TableRow
                      key={element.userId + index}
                      style={index % 2 ? { background: "white" } : { background: "#f6f6f6", borderBottomColor: "rgba(0,0,0,.12)" }} >
                      <TableCell
                        className='coordinator_tableBodyCell'
                        style={{ padding: '0px', maxHeight: '10px !important', width: '130px' }}>
                        {!editableRows.includes(element.userId + index) && (
                          <>
                            <Button
                              className='actionCrtlsBtn'
                              onClick={() => switchUser(
                                element
                              )}
                            >
                              <Tooltip title='District Coordinator view' placement="bottom-start">
                                <><img
                                  src={element.userId === mapUserID
                                    ? require('../../assets/images/disInfo_new.png')
                                    : require('../../assets/images/Info_new.png')}
                                  className="actionCtrls"
                                  alt="Switch DC User"
                                  title="District Coordinator view" /></>
                              </Tooltip>
                            </Button>

                            <Button className='actionCrtlsBtn' 
                            onClick={() => {
                              if (localStorage.getItem("selectedYear") !== "") {
                                handleYearSelection()
                              } else {
                                handleEditClick(element, element.userId + index);
                              }
                            }}
                            >
                              <Tooltip title='Edit DC account and survey status' placement="bottom-start">
                                <><img
                                  // src={require('../../assets/images/editDC.png')}
                                  src={editDCIcon}
                                  className="actionCtrls"
                                  alt="Edit DC User"
                                  title="Edit DC account and survey status"
                                /></></Tooltip>
                            </Button>

                            <Button className='actionCrtlsBtn' 
                            onClick={() => {
                              if (localStorage.getItem("selectedYear") !== "") {
                                handleYearSelection()
                              } else {
                                toggleModal(element.userId, element);
                              }
                            }}
                            >
                              <Tooltip title='Add district for user' placement="bottom-start">
                                <><img
                                  // src={require("../../assets/images/addDC.png")}
                                  src={addDc}
                                  className="actionCtrls"
                                  alt="Add DC User"
                                  title="Add district for user" /></>
                              </Tooltip>
                            </Button>

                            <Button className='actionCrtlsBtn' 
                            onClick={() => {
                              if (localStorage.getItem("selectedYear") !== "") {
                                handleYearSelection()
                              } else {
                                handleOpen(element.userId, element, index);
                              }
                            }}
                            >
                              <Tooltip title='Delete district for user' placement="bottom-start">
                                <><img
                                  // src={require("../../assets/images/deleteDC.png")}
                                  src={deleteDC}
                                  className="actionCtrls"
                                  alt="Delete DC User"
                                  title="Delete district for user" /></>
                              </Tooltip>
                            </Button>
                            <Button className='actionCrtlsBtn'
                              onClick={() => {
                                if (localStorage.getItem("selectedYear") !== "") {
                                  handleYearSelection()
                                } else {
                                  handleUserDetailsClick(element, element.userId, index);
                                }
                              }}
                             >
                              <Tooltip title='Edit user profile' placement="bottom-start">
                                <><img
                                  // src={require('../../assets/images/editUser1.png')}
                                  src={editUser1}
                                  className="actionCtrls"
                                  alt="Edit User"
                                  title="Edit user profile"
                                /></></Tooltip>
                            </Button>

                            <Button className='actionCrtlsBtn' 
                             onClick={() => {
                              if (localStorage.getItem("selectedYear") !== "") {
                                handleYearSelection()
                              } else {
                                handleTransferOwnershipOpen(element, element.userId, index);
                              }
                            }}
                            >
                              <Tooltip title='Transfer DC ownership' placement="bottom-start">
                                <><img
                                  // src={require("../../assets/images/transferOwnership.png")}
                                  src={transferOwnership}
                                  className="actionCtrls"
                                  alt="Transfer of Ownership"
                                  title="Transfer DC ownership" /></>
                              </Tooltip>
                            </Button>
                          </>
                        )}
                        {editableRows.includes(element.userId + index) && (
                          <>
                            <Button onClick={() => handleSaveClick(element, index)}>
                              <img
                                // src={require("../../assets/images/save_close.png")}
                                src={saveIcon}
                                className="actionCtrls"
                                alt="Save"
                                title="Save Changes" />
                            </Button>
                            <Button onClick={() => discardRow(element.userId + index)}>
                              <img
                                // src={require("../../assets/images/discard.png")}
                                src={discardIcon}
                                className="actionCtrls"
                                alt="Discard"
                                title="Discard Changes" />
                            </Button>
                          </>
                        )}
                      </TableCell>
                      <TableCell className='coordinator_tableBodyCell coordinator_tableBodySize12' sx={{ width: '90px' }}>{element.county}</TableCell>
                      <TableCell className='coordinator_tableBodyCell coordinator_tableBodySize12' sx={{ width: '250px' }}>{element.district}</TableCell>
                      <TableCell className='coordinator_tableBodyCell coordinator_tableBodySize12' sx={{ width: '20px' }}>{element.firstName}</TableCell>
                      <TableCell className='coordinator_tableBodyCell coordinator_tableBodySize12' sx={{ width: '30px' }}>{element.lastName}</TableCell>
                      <TableCell className='coordinator_tableBodyCell coordinator_tableBodySize12' sx={{ width: '30px' }}>
                        <span>{element.email}</span>
                      </TableCell>
                      <TableCell className='coordinator_tableBodyCell coordinator_tableBodySize12' sx={{ width: '30px' }}>
                        {element.phone}
                      </TableCell>
                      <TableCell className='coordinator_tableBodyCell coordinator_tableBodySize12' sx={{ width: '100px' }}>
                        {element.city}
                      </TableCell>
                      <TableCell className='coordinator_tableBodyCell coordinator_tableBodySize12' sx={{ width: '30px' }}>
                        {element.zipCode}
                      </TableCell>
                      <TableCell className='coordinator_tableBodyCell coordinator_tableBodySize12 coor_approval' sx={{ width: '20px' }}>
                        {editableRows.includes(element.userId + index) ? (
                          <Select
                            value={selectedUserApproveStatus}
                            onChange={(e) => {
                              element.approveStatus = e.target.value;
                              setSelectedUserApproveStatus(e.target.value)
                            }}
                            // onChange={(e) => onSelectUserApprooveStatus(e.target.value)}
                            className="statusDD"
                            style={{ minWidth: '40px', height: '25px' }}
                            placeholder="Approve Status"
                          >
                            <MenuItem value="yes">Yes</MenuItem>
                            <MenuItem value="no">No</MenuItem>
                          </Select>
                        ) : (
                          <span style={{ textTransform: 'capitalize' }}>
                            {element.approveStatus}
                          </span>
                        )}
                      </TableCell>
                      <TableCell className='coordinator_tableBodyCell coordinator_tableBodySize12 coor_approval' sx={{ width: '20px' }}>
                        <div>
                          {!editableRows.includes(element.userId + index) ? (
                            element.distSubmitType != 'do' ?
                              <span style={{ textTransform: 'capitalize' }}> {element.submitStatus}</span> :
                              <span style={{ color: 'red' }}> n/a </span>
                          ) : (
                            element.distSubmitType != 'do' ?
                              <Select
                                value={selectedReportSubmitStatus}
                                onChange={(e) => {
                                  element.submitStatus = e.target.value;
                                  setSelectedReportSubmitStatus(e.target.value);
                                  if (e.target.value == 'no') {
                                    element.reportPage = 'no';
                                    setSelectedOrderReport('no');
                                  }
                                }}
                                className="statusDD"
                                style={{ minWidth: '40px', height: '25px' }}
                              >
                                <MenuItem value="yes">Yes</MenuItem>
                                <MenuItem value="no">No</MenuItem>
                              </Select> :
                              <Select
                                value={selectedReportSubmitStatus}
                                onChange={(e) => {
                                  element.submitStatus = e.target.value;
                                  setSelectedReportSubmitStatus(e.target.value);
                                  if (e.target.value == 'no') {
                                    element.reportPage = 'no';
                                    setSelectedOrderReport('no');
                                  }
                                }}
                                className="statusDD"
                                style={{ minWidth: '40px', height: '25px' }}
                              >
                                <MenuItem value="yes">n/a</MenuItem>
                                <MenuItem value="no">active</MenuItem>
                              </Select>

                          )}
                        </div>
                      </TableCell>
                      <TableCell className='coordinator_tableBodyCell coordinator_tableBodySize12 coor_approval' sx={{ width: '20px' }}>
                        {!editableRows.includes(element.userId + index) ? (
                          <span style={{ textTransform: 'capitalize' }}>{element.reportPage}</span>
                        ) : (
                          <Select
                            value={selectedOrderReport}
                            onChange={(e) => {
                              element.reportPage = e.target.value;
                              if (selectedReportSubmitStatus == 'no') {
                                setSelectedOrderReport('no');
                                element.reportPage = 'no';
                              } else {
                                setSelectedOrderReport(e.target.value);
                              }
                            }}
                            className="statusDD"
                            style={{ minWidth: '40px', height: '25px' }}
                          >
                            <MenuItem value="yes">Yes</MenuItem>
                            <MenuItem value="no">No</MenuItem>
                          </Select>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Dialog open={isModalOpen} onClose={toggleModal} aria-labelledby="dialog-title" disableEscapeKeyDown>
            <DialogTitle id="dialog-title">Add a District</DialogTitle>
            <DialogContent>
              <Grid item xl={4}>
                <FormControl variant="standard" style={{ ...isCountyError ? { color: '#d32f2f', fontSize: '12px', width: '350px', marginTop: '15px' } : { color: '#3f51b5', fontSize: '12px', width: '350px', marginTop: '15px' } }}>
                  <InputLabel id="county-label" style={{ ...isCountyError ? { color: '#d32f2f', fontSize: '12px' } : { color: '#3f51b5', fontSize: '12px' } }} >Select County</InputLabel>
                  <Select
                    labelId="county-label"
                    value={selectedAddCounty}
                    onChange={onAddCountySelect}
                    MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                    onBlur={() => {
                      if (selectedAddCounty == '') {
                        setIsCountyError(true);
                      }
                    }}
                  >
                    <MenuItem value="">SELECT COUNTY</MenuItem>
                    {countylist.map((county) => (
                      <MenuItem key={county._id} value={county._id}>
                        {county.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {isCountyError && <FormHelperText style={{ ...isCountyError ? { color: '#d32f2f' } : '' }}>Required field</FormHelperText>}
                </FormControl>
              </Grid>

              <Grid item xl={4}>
                <FormControl variant="standard" style={{ ...isDistrictError ? { color: '#d32f2f', fontSize: '12px', width: '350px', marginTop: '15px' } : { color: '#3f51b5', fontSize: '12px', width: '350px', marginTop: '15px' } }}>
                  <InputLabel id="district-label" style={{ ...isDistrictError ? { color: '#d32f2f', fontSize: '12px' } : { color: '#3f51b5', fontSize: '12px' } }}>Select District</InputLabel>
                  <Select
                    labelId="district-label"
                    value={selectedAddDistrict}
                    onChange={onAddDistrictSelect}
                    MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                    onBlur={() => {
                      if (selectedAddDistrict == '') {
                        setIsDistrictError(true);
                      }
                    }}
                  >
                    <MenuItem value="">SELECT DISTRICT</MenuItem>
                    {sortedDistricts.map((dist) => (
                      <MenuItem key={dist._id} value={dist._id}>
                        {dist.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {isDistrictError && <FormHelperText style={{ ...isDistrictError ? { color: '#d32f2f' } : '' }}>Required field</FormHelperText>}
                </FormControl>
              </Grid>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'left', marginTop: '5px', marginBottom: '20px' }}>
              {isCountyError || isDistrictError || selectedAddCounty == '' || selectedAddDistrict == '' ?
                <Button style={{ cursor: 'pointer', backgroundColor: '#f6e9e9', color: 'rgba(0,0,0,.26)', height: '35px', width: '68px', padding: '6px' }} disabled onClick={handleDistrictSave}>
                  Save
                </Button> :
                <Button style={{ cursor: 'pointer', backgroundColor: '#f6e9e9', color: '#3f51b5', height: '35px', width: '68px', padding: '6px' }} onClick={handleDistrictSave}>
                  Save
                </Button>
              }
              <Button style={{ cursor: 'pointer', backgroundColor: '#f6e9e9', color: '#ff4081', height: '35px', width: '68px', padding: '6px' }} onClick={toggleModal}>
                Cancel
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={open} onClose={handleClose} aria-labelledby="dialog-title" disableEscapeKeyDown>
            <DialogTitle id="dialog-title">Delete District</DialogTitle>
            <DialogContent>
              <p className='deletePara'>
                {deleteDcPopMessage}
              </p>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
              <Button style={{ cursor: 'pointer', backgroundColor: '#ff0000', color: 'white', height: '32px', width: '64px', padding: '4px' }} onClick={handleClose}>
                NO
              </Button>
              <Button style={{ cursor: 'pointer', backgroundColor: '#1f9d24', color: 'white', height: '32px', width: '64px', padding: '4px' }} onClick={deleteUser}>
                YES
              </Button>
            </DialogActions>
          </Dialog>


          {/* Transfer of District */}
          <Dialog open={transferOwnershipOpen} onClose={handleTransferOwnershipClose} aria-labelledby="dialog-title" disableEscapeKeyDown>
            <DialogTitle id="dialog-title">Transfer DC ownership</DialogTitle>
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControl
                    style={{
                      ...isUserError ?
                        { color: '#d32f2f', fontSize: '12px', width: '350px', marginTop: '15px' } :
                        { color: '#3f51b5', fontSize: '12px', width: '350px', marginTop: '15px' }
                    }}
                    fullWidth variant="standard" error={isUserError}
                  >
                    <InputLabel id="county-label" style={{ ...isUserError ? { color: '#3f51b5', fontSize: '12px' } : { color: '#d32f2f', fontSize: '12px' } }} >Select DC User</InputLabel>
                    <Select
                      labelId="county-label"
                      label="Select DC User"
                      value={selectedTransferUserId}
                      onChange={handleUserSelect}
                      MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                    >
                      <MenuItem value="SELECT DC USER">SELECT DC USER</MenuItem>
                      {
                        uniqueUsers.map((user) => (
                          <MenuItem key={user.userId} value={user.userId}>
                            {user.email}
                          </MenuItem>
                        ))}
                    </Select>
                    {isUserError && selectedTransferUserId == 'SELECT DC USER' && <FormHelperText >Please select a DC user.</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'left', marginTop: '5px', marginBottom: '40px' }}>
              {/* <Button style={{ cursor: 'pointer', backgroundColor: '#f6e9e9', color: '#ff4081', height: '35px', width: '68px', padding: '4px' }} onClick={handleTransferDistrict}>
                Save
              </Button> */}

              {selectedTransferUserId == 'SELECT DC USER' || !selectedTransferUserId && isUserError ?
                <Button style={{ cursor: 'pointer', backgroundColor: '#f6e9e9', color: 'rgba(0,0,0,.26)', height: '35px', width: '68px', padding: '6px' }} disabled onClick={handleTransferDistrict}>
                  Save
                </Button> :
                <Button style={{ cursor: 'pointer', backgroundColor: '#f6e9e9', color: '#3f51b5', height: '35px', width: '68px', padding: '6px' }} onClick={handleTransferDistrict}>
                  Save
                </Button>
              }

              <Button style={{ cursor: 'pointer', backgroundColor: '#f6e9e9', color: '#ff4081', height: '35px', width: '68px', padding: '4px' }} onClick={handleTransferOwnershipClose}>
                Cancel
              </Button>
            </DialogActions>
          </Dialog>

          {/* User Details Popup */}
          <Dialog open={userDetailsOpen} onClose={handleUserDetailsClose} aria-labelledby="dialog-title" disableEscapeKeyDown>
            <DialogTitle id="dialog-title">Edit User</DialogTitle>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl style={{ width: '350px' }} fullWidth variant="standard" error={isUserError.firstNameError}>
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      labelId="FName"
                      label="First Name"
                      name="firstName"
                      value={userDetailState.firstName}
                      onChange={handleInputChange}
                      onBlur={() => { validateForm(); }}
                    />
                    {isUserError.firstNameError && <FormHelperText>Please enter a first name.</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl style={{ width: '350px', marginTop: '15px' }} fullWidth variant="standard" error={isUserError.lastNameError}>
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      labelId="LName"
                      label="Last Name"
                      name="lastName"
                      value={userDetailState.lastName}
                      onChange={handleInputChange}
                      onBlur={() => { validateForm(); }}
                    />
                    {isUserError.lastNameError && <FormHelperText>Please enter a last name.</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl style={{ width: '350px', marginTop: '15px' }} fullWidth variant="standard" error={isUserError.phoneError}>
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      labelId="Phone"
                      label="Phone"
                      name="phone"
                      value={userDetailState.phone}
                      onChange={handleInputChange}
                      onBlur={() => { validateForm(); }}
                    />
                    {isUserError.phoneError && <FormHelperText>Please enter a valid phone number.</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl style={{ width: '350px', marginTop: '15px' }} fullWidth variant="standard" error={isUserError.zipCodeError}>
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      labelId="zipCode"
                      label="City zip code"
                      name="zipCode"
                      value={userDetailState.zipCode}
                      onChange={handleInputChange}
                      onBlur={() => { validateForm(); }}
                    />
                    {isUserError.zipCodeError && <FormHelperText>Please enter a valid zip code.</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>


              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl style={{ width: '350px', marginTop: '15px' }} fullWidth variant="standard" error={isUserError.cityError}>
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      labelId="city"
                      label="City"
                      name="city"
                      value={userDetailState.city}
                      onChange={handleInputChange}
                      onBlur={() => { validateForm(); }}
                    />
                    {isUserError.cityError && <FormHelperText>Please enter a City.</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>


              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl style={{ width: '350px', marginTop: '15px' }} fullWidth variant="standard" error={isUserError.addressError}>
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      labelId="address"
                      label="Address"
                      name="address"
                      value={userDetailState.address}
                      onChange={handleInputChange}
                      onBlur={() => { validateForm(); }}
                    />
                    {isUserError.addressError && <FormHelperText>Please enter a address.</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'left', marginTop: '5px', marginBottom: '20px' }} >
              {isUserError.firstNameError != '' || isUserError.lastNameError != '' || isUserError.phoneError != '' || isUserError.zipCodeError != '' || isUserError.cityError != '' || isUserError.addressError != '' ?
                <Button style={{ cursor: 'pointer', backgroundColor: '#f6e9e9', color: 'rgba(0,0,0,.26)', height: '35px', width: '68px', padding: '6px' }} disabled onClick={handleUserDetailsUpdate}>
                  Save
                </Button> :
                <Button style={{ cursor: 'pointer', backgroundColor: '#f6e9e9', color: '#3f51b5', height: '35px', width: '68px', padding: '6px' }} onClick={handleUserDetailsUpdate}>
                  Save
                </Button>
              }
              <Button
                style={{
                  cursor: 'pointer',
                  backgroundColor: '#f6e9e9',
                  color: '#ff4081',
                  height: '32px',
                  width: '64px',
                  padding: '4px'
                }}
                onClick={handleUserDetailsClose}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>

          <TablePagination
            rowsPerPageOptions={[100, 200, 400, 600, 800, 1000, 2000]}
            component="div"
            count={dcdata.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage={"Items per page"}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              '.MuiTablePagination-toolbar': {
                color: 'rgba(0,0,0,.54)',
              },
            }} />
        </div>
      </div>
    </>

  );
}

export default Coordinator;